import ApiHandler from "./ApiHandler";

const LocationStep = {
  deleteAppealDate: async (locationStepId) => await ApiHandler.i.auth().delete(`/location-step/${locationStepId}/appeal-date`),
  deleteInstruction: async (locationStepId) => await ApiHandler.i.auth().delete(`/location-step/${locationStepId}/instruction`),
  findAll: async (query) => await ApiHandler.i.auth().get(`/location-step/find-all?${query.toString()}`),
  findOne: async (query) => await ApiHandler.i.auth().get(`/location-step/find-one?${query.toString()}`),
  putOne: async (locationStepId, data, options) => await ApiHandler.i.auth().put(`/location-step/${locationStepId}`, data, options),
  putVariant: async (locationStepId, data, options) => await ApiHandler.i.auth().put(`/location-step/${locationStepId}/variant`, data, options),
};

export default LocationStep;